import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Tutorials = () => {
  return (
    <React.Fragment>
      <SEO title="Tutorials | ICSI 2024" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Tutorials"
        content="The Conference"
        contentTwo="Tutorials"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <h3>ICSI Call for Tutorial Proposals</h3>
          <p align="justify">
            ICSI 2024 technical program will include tutorial sessions. Their
            aim is to provide a fast introduction to some topics of interest to
            the swarm intelligence community.{" "}
          </p>
          <p align="justify">
            Prospective organizers of tutorial sessions should submit proposals
            indicating:
          </p>
          <p align="left">
            * Title of the tutorial.
            <br />
            * Rationale of the need for the tutorial at ICSI.
            <br />
            * Short biography and recent photo of the organizers.
            <br />
          </p>
          <p align="justify">
            Proposals are due on or before Jan 28, 2024 and should be sent via
            e-mail (in either pdf or plain ASCII text form) to the tutorial
            sessions chairs (to be announced) and forward to ICSI 2024
            secretariat at{" "}
            <a href="mailto: icsi2024@iasei.org">icsi2024@iasei.org</a>
          </p>
          <p align="justify">
            Notification of acceptance will be sent to the organizers no later
            than Feb 28, 2024.
          </p>
          <p>&nbsp;</p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Tutorials;
